import { render, staticRenderFns } from "./BrbInput.vue?vue&type=template&id=cfc32294&"
import script from "./BrbInput.vue?vue&type=script&lang=js&"
export * from "./BrbInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc32294')) {
      api.createRecord('cfc32294', component.options)
    } else {
      api.reload('cfc32294', component.options)
    }
    module.hot.accept("./BrbInput.vue?vue&type=template&id=cfc32294&", function () {
      api.rerender('cfc32294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbInput.vue"
export default component.exports